// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__130bS","bigColWidth":"Table_bigColWidth__Jjbel","biggerColWidth":"Table_biggerColWidth__2mfbZ","row":"Table_row__PO4O8","col":"Table_col__2RB44"};